import { defineMessages } from "react-intl";

import {
	validator,
	valueMessages
} from "lib/build/forms/ltx/phase-i/lab-procedures/standard-lab-procedures/coombsIndirect";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	coombsIndirect: {
		id: "form.coombs_indirect",
		defaultMessage: "Coombs indirekt"
	},
	value: {
		id: "form.coombs_indirect.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: valueMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "coombsIndirect",
	value: {
		title: messages.coombsIndirect,
		validator,
		fieldset,
		isImportant: true
	}
};
